import { render, staticRenderFns } from "./AnalysisQuizAnswer.vue?vue&type=template&id=7f4c0b40"
import script from "./AnalysisQuizAnswer.vue?vue&type=script&lang=js"
export * from "./AnalysisQuizAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports